'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Set as ImmutableSet } from 'immutable';
import AdEditRecord from '../records/ad-management/AdEditRecord';
export default ((state = AdEditRecord(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.AD_EDIT_UPDATE:
      {
        return state.merge(payload);
      }

    case Actions.AD_EDIT_UPDATE_CHANGE:
      {
        const {
          key,
          value
        } = payload;
        return state.set(key, value).updateIn(['changes'], changes => changes.add(key));
      }

    case Actions.AD_EDIT_RESET:
      {
        return state.mergeDeep(AdEditRecord());
      }

    case Actions.AD_EDIT_RESET_CHANGES:
      {
        return state.set('changes', ImmutableSet([]));
      }

    default:
      {
        return state;
      }
  }
});